import { useEffect } from "react";
import { useMap, useMapEvents } from "react-leaflet";

const MyComponent = ({
  radius,
  showAndHideTooltips,
  setToolTipIndex,
}) => {
  const map = useMap();
  const mapEvents = useMapEvents({
    zoomend: () => {
      const currentZoom = map.getZoom();
      if (currentZoom >= 10) {
        showAndHideTooltips(true); // Show tooltips when zoom is 10 or higher
      } else {
        showAndHideTooltips(false); // Hide tooltips when zoom is below 10
        setToolTipIndex(-1);
      }
    },
    zoom: (e) => {
      localStorage.setItem("zoom", mapEvents.getZoom());
      localStorage.setItem("lng", e.target.getCenter().lng);
      localStorage.setItem("lat", e.target.getCenter().lat);
    },
    dragend: (e) => {
      localStorage.setItem("lng", e.target.getCenter().lng);
      localStorage.setItem("lat", e.target.getCenter().lat);
    },
  });

  // Only sync when radius changes — calling setZoom on every render
  // was cancelling User Location flyTo/setView after pan/zoom.
  useEffect(() => {
    if (radius == null || radius === "") return;
    const nextZoom = Number(radius);
    if (!Number.isFinite(nextZoom)) return;
    if (map.getZoom() !== nextZoom) {
      map.setZoom(nextZoom);
    }
  }, [radius, map]);

  return null;
}

export default MyComponent;
